import parse from 'html-react-parser';
import React, { useContext } from 'react';
import { NotesContext } from '../../contexts/NotesContext';
import { subjectTypes } from '../../@types/entities/subjects.entity';
import PriorityHighIcon from '../../assets/icons/priority-high';
import { BoxContainer, ReminderContainer, WrapIcon } from './styles';

export type IReminder = {
  content: string;
  subject: subjectTypes | string;
};

export default function ReminderBox({ content, subject }: IReminder) {
  const { replace } = useContext(NotesContext);

  return (
    <ReminderContainer>
      <BoxContainer $subject={subject}>
        {parse(content, { replace })}
      </BoxContainer>
    </ReminderContainer>
  );
}
